import React from 'react'

const AdvertisementAdmin = () => {
    return (
        <div>

        </div>
    )
}

export default AdvertisementAdmin
